import React, { useMemo, useState } from 'react';
import DataGrid, { Lookup, Column, Selection, FilterRow } from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import Form, { GroupItem, SimpleItem, Label } from "devextreme-react/form";
import IRapportZ from "../../models/IRapportZ";
import useCustomDataSource, { Mode } from "../../hooks/useCustomDataSource";
import ScrollView from 'devextreme-react/scroll-view';
import Guid from "../../models/Guid";

export default function GestionTransfertAcomba() {
  const rapportZFormDataSource = useCustomDataSource<IRapportZ, IRapportZ>({ path: "client", primaryKey: "idClient", customReadAllPath: "client/read-list" });
  const { selectedDataRow: selectedRapportZ, setSelectedDataRow, setIsFieldModifier, mode } = rapportZFormDataSource;
  const [isPopupVisible, setIsPopupVisible] = useState(true);

  const dateEditorOptions = useMemo(() => {
    return {
      type: "datetime",
      displayFormat: "dd-MM-yyyy HH:mm",
      width: "85%"
    };
  }, []);

  const spinEditorOptions = useMemo(() => {
    return {
      min: 0,
      showSpinButtons: true
    };
  }, []);

  return <Popup
    visible={isPopupVisible}
    // visible={this.state.popupVisible}
    // onHiding={this.hideInfo}
    dragEnabled={true}
    resizeEnabled={true}
    hideOnOutsideClick={true}
    showCloseButton={false}
    showTitle={true}
    dragOutsideBoundary={true}
    title="Transfert vers Acomba"
    container=".dx-viewport"
    width={325}
    height={"content"}
  >
    <ScrollView width='100%' height='100%'>
      {/* <FormListBase data={rapportZFormDataSource}> */}
      {/* <FormListBaseTab> */}
      {/* <TabItem title="Liste des clients à fusionner"> */}
      <Form readOnly={mode === Mode.Lecture} alignItemLabelsInAllGroups={true} formData={selectedRapportZ || {} as IRapportZ} className={"forms"} labelLocation={"left"} showColonAfterLabel={true}>
        <GroupItem>
          <SimpleItem key={"fml-dateDebut"} dataField={"dateDebut"} editorType={"dxDateBox"} editorOptions={dateEditorOptions}>
            <Label text="Date début" />
          </SimpleItem>
          <SimpleItem key={"fml-dateFin"} dataField={"dateFin"} editorType={"dxDateBox"} editorOptions={dateEditorOptions}>
            <Label text="Date fin" />
          </SimpleItem>
          <SimpleItem key={"fml-usagerDebut"} dataField={"usagerDebut"} editorType={"dxSelectBox"}>
            <Label text="Usager début" />
          </SimpleItem>
          <SimpleItem key={"fml-usagerFin"} dataField={"usagerFin"} editorType={"dxSelectBox"}>
            <Label text="Usager fin" />
          </SimpleItem>
          <SimpleItem key={"fml-posteDebut"} dataField={"posteDebut"} editorType={"dxSelectBox"}>
            <Label text="Poste début" />
          </SimpleItem>
          <SimpleItem key={"fml-posteFin"} dataField={"posteFin"} editorType={"dxSelectBox"}>
            <Label text="Poste fin" />
          </SimpleItem>
          <SimpleItem key={"fml-numeroLot"} dataField={"numeroLot"} editorType={"dxNumberBox"} editorOptions={spinEditorOptions}>
            <Label text="Numéro de lot" />
          </SimpleItem>
        </GroupItem>
      </Form>
      {/* </TabItem > */}
      {/* </FormListBaseTab > */}
      {/* </FormListBase > */}
    </ScrollView >
  </Popup >
}
